<template>
  <CastFinder />
</template>

<script>
  import CastFinder from './components/CastFinder.vue';

  export default {
    name: 'App',
    components: {
      CastFinder
    }
  }
</script>

<style>
  #app {
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
